const KEY_PREFIX = 'vello.secure.';
export class WebSecureStore {
    storage;
    memory = new Map();
    /**
     * Acknowledged read of the shared `localStorage` — no memory fallback: a throwing read is `ok: false` (ADR-0039 amendment
     * 4). With NO backing storage at all this context shares nothing with any other, so its memory is the authority.
     */
    getShared(key) {
        const k = KEY_PREFIX + key;
        if (this.storage === undefined)
            return Promise.resolve({ ok: true, value: this.memory.get(k) });
        try {
            const v = this.storage.getItem(k);
            return Promise.resolve({ ok: true, value: v === null ? undefined : v });
        }
        catch {
            return Promise.resolve({ ok: false });
        }
    }
    /** Acknowledged write: true only if the shared `localStorage` now holds exactly `value` (read back). */
    setShared(key, value) {
        const k = KEY_PREFIX + key;
        if (this.storage === undefined) {
            this.memory.set(k, value);
            return Promise.resolve(true);
        }
        try {
            this.storage.setItem(k, value);
            if (this.storage.getItem(k) !== value)
                return Promise.resolve(false);
            this.memory.set(k, value);
            return Promise.resolve(true);
        }
        catch {
            return Promise.resolve(false);
        }
    }
    /** @param storage the backing store; defaults to the runtime `localStorage` when omitted. */
    constructor(storage) {
        this.storage = storage ?? resolveLocalStorage();
    }
    get(key) {
        const k = KEY_PREFIX + key;
        if (this.storage !== undefined) {
            try {
                const v = this.storage.getItem(k);
                return Promise.resolve(v === null ? undefined : v);
            }
            catch {
                /* fall through to memory */
            }
        }
        return Promise.resolve(this.memory.get(k));
    }
    set(key, value) {
        const k = KEY_PREFIX + key;
        this.memory.set(k, value);
        if (this.storage !== undefined) {
            try {
                this.storage.setItem(k, value);
            }
            catch {
                /* memory already holds it */
            }
        }
        return Promise.resolve();
    }
    remove(key) {
        const k = KEY_PREFIX + key;
        this.memory.delete(k);
        if (this.storage !== undefined) {
            try {
                this.storage.removeItem(k);
            }
            catch {
                /* nothing else to do */
            }
        }
        return Promise.resolve();
    }
}
/** Resolve the runtime `localStorage`, or `undefined` when it is absent or access throws. */
export function resolveLocalStorage() {
    try {
        const g = globalThis;
        return g.localStorage;
    }
    catch {
        return undefined;
    }
}
//# sourceMappingURL=web-secure-store.js.map